export default __webpack_public_path__ + "static/left-7b2300205dcaeb84a916e57c246aed6e.png";